export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center">
      <div className="w-full max-w-md mx-4 rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center">
        <h1 className="text-2xl font-bold mb-2">404 - Page Not Found</h1>
        <p className="text-muted-foreground">
          The page you are looking for does not exist.
        </p>
        <a
          href="/"
          className="text-primary hover:underline mt-4 inline-block"
        >
          Go Home
        </a>
      </div>
    </div>
  );
}
